import type { FaireProductEntity } from "../../entity_types/product";

export const p_3prhvv97tc: FaireProductEntity = {
  token: "p_3prhvv97tc",
  type: "product",
  name: "Rooted In Jesus Kids Hoodie",
  brandToken: "b_fnw2e7p4xp",
  brandName: "BRVE by Fletch",
  imageUrl:
    "https://cdn.faire.com/fastly/6d5afe7752aa2dd9efd7d48a9d427464050929bd606f2c644ca68330ab35f2eb.png",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/6dcbf1364ad5fd374e43ee000dab6fcf18f80509f23f42643ee7ec8b4ee1fb94.jpeg",
    "https://cdn.faire.com/fastly/0c6204942aa91285d765823168c68f2e55b96968efc8c0960118d9ef6b12483a.jpeg",
    "https://cdn.faire.com/fastly/95ccddd4471d2880cb7a8992f1420f445a2aff976b9026e7e13673505590ecd7.jpeg",
    "https://cdn.faire.com/fastly/72a03448056bd791629b77185704f9873e863da0a7f68502d038bf9adb3ffc2f.jpeg",
    "https://cdn.faire.com/fastly/079e303ffa8c9153e1fdb5c8401509888e465213f2beb7491bba5908b0602606.jpeg",
    "https://cdn.faire.com/fastly/feacc75a64bb6177ed63ba68aed820178dcf232a6720a0c381a0a656d2fbe675.jpeg",
    "https://cdn.faire.com/fastly/ed680fd49589dd3a69a99d42467443efb02a78502691c29857f2fec3b31a67fb.jpeg",
  ],
  priceDollars: 22.8,
  description:
    "\n\nWrap your little one in comfort and purpose with the BRVE Hoodie — designed for everyday wear and eternal reminders. This isn’t just another hoodie; it’s a statement of identity and courage.\n\n✨ Fabric You’ll Love:\nMade from a premium blend of 70% bamboo, 25% cotton, and 5% spandex, this hoodie is buttery-soft, breathable, and flexible — perfect for play, school, or cozy nights in.\n\n✨ Designed with Purpose:\nMarked with the BRVE logo, each hoodie is a reminder that our kids are called to be bold, rooted in truth, and shining God’s light in their world.\n\n✨ Made for Everyday:\nDurable, versatile, and designed for movement — this hoodie goes where your kids go, turning ordinary routines into opportunities to live brave.\n\nWith BRVE, your kids aren’t just wearing clothes — they’re carrying a mission.\n",
  tags: [],
  msrpDollars: 45.6,
  inStock: false,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:49:03.795Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
